const pagesDeviceCatalogAddEn = {
  intro: {
    header: {
      headerTitle: "Create Device Catalog",
    },
    body: {
      itemCard: {
        requiredDetails: "Required:",
        deviceCategory: "Category",
        catalogName: "Catalog Name",
      },
      selectDeviceType: "Select Device Type",
      fillOutDetails: "Fill Out Details",
    },
  },
  form: {
    title: "Basic Information",
    catalogNameLabel: "Catalog Name",
    catalogNamePlaceholder: "Enter catalog name",
    categoryLabel: "Category",
    manufacturerLabel: "Manufacturer",
    manufacturerPlaceholder: "Enter manufacturer",
    modelLabel: "Model",
    modelPlaceholder: "Enter model",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter description",
    submitButtonLabel: "Create Catalog",
    navigation: {
      steps: {
        basic: {
          title: "Basic",
          catalogNameLabel: "Catalog Name",
          catalogNamePlaceholder: "Enter catalog name",
          categoryLabel: "Category",
          manufacturerLabel: "Manufacturer",
          manufacturerPlaceholder: "Enter manufacturer",
          modelLabel: "Model",
          modelPlaceholder: "Enter model",
          modelNumberLabel: "Model Number",
          modelNumberPlaceholder: "Enter model number",
          descriptionLabel: "Description",
          descriptionPlaceholder: "Enter description",
          codeLabel: "Code",
          codePlaceholder: "Enter code",
        },
        firmware: {
          title: "BIOS/Firmware",
          biosVendorLabel: "BIOS Vendor",
          biosVendorPlaceholder: "Enter BIOS Vendor",
          biosVersionLabel: "BIOS Version",
          biosVersionPlaceholder: "Enter BIOS Version",
          biosReleaseDateLabel: "BIOS Release Date",
          biosReleaseDatePlaceholder: "Select BIOS Release Date",
          firmwareTypeLabel: "Firmware Type",
          firmwareTypePlaceholder: "Enter Firmware Type",
          firmwareModeLabel: "Firmware Mode",
          firmwareModePlaceholder: "Enter Firmware Mode",
          biosUpdateEnabledLabel: "BIOS Update Enabled",
          secureBootEnabledLabel: "Secure Boot Enabled",
          biosPasswordSetLabel: "BIOS Password Set",
          tpmEnabledLabel: "TPM Enabled",
          tpmVersionLabel: "TPM Version",
          tpmVersionPlaceholder: "Enter TPM Version",
          intelTrustedExecutionTechnologyLabel:
            "Intel Trusted Execution Technology",
          biosLockWriteProtectionLabel: "BIOS Lock Write Protection",
          hardwareEncryptionSupportLabel: "Hardware Encryption Support",
          systemUuidLabel: "System UUID",
          systemUuidPlaceholder: "Enter System UUID",
          smbiosVersionLabel: "SMBIOS Version",
          smbiosVersionPlaceholder: "Enter SMBIOS Version",
          biosRomSizeBytesLabel: "BIOS ROM Size (Bytes)",
          biosRomSizeBytesPlaceholder: "Enter BIOS ROM Size in Bytes",
          bootSequenceOrderLabel: "Boot Sequence / Order",
          bootSequenceOrderPlaceholder: "Enter Boot Sequence or Order",
          wakeOnLanEnabledLabel: "Wake-on-LAN Status",
          pxeBootEnabledLabel: "PXE Boot Enabled",
          motherboardModelLabel: "Motherboard Model",
          motherboardModelPlaceholder: "Enter Motherboard Model",
          systemSerialNumberLabel: "System Serial Number",
          systemSerialNumberPlaceholder: "Enter System Serial Number",
          systemManufacturerLabel: "System Manufacturer",
          systemManufacturerPlaceholder: "Enter System Manufacturer",
          systemModelLabel: "System Model",
          systemModelPlaceholder: "Enter System Model",
          oemBiosCustomizationLabel: "OEM BIOS Customization",
          oemBiosCustomizationPlaceholder: "Enter OEM BIOS Customization",
        },
        gpu: {
          title: "GPU",
          gpuNameLabel: "GPU Name",
          gpuNamePlaceholder: "Enter GPU Name",
          gpuVendorLabel: "GPU Vendor",
          gpuVendorPlaceholder: "Enter GPU Vendor",
          gpuModelNumberLabel: "GPU Model Number",
          gpuModelNumberPlaceholder: "Enter GPU Model Number",
          gpuGenerationLabel: "GPU Generation",
          gpuGenerationPlaceholder: "Enter GPU Generation",
          gpuArchitectureLabel: "GPU Architecture",
          gpuArchitecturePlaceholder: "Enter GPU Architecture",
          gpuDedicatedMemoryBytesLabel: "Dedicated Memory (Bytes)",
          gpuDedicatedMemoryBytesPlaceholder: "Enter Dedicated Memory (Bytes)",
          gpuSharedMemoryBytesLabel: "Shared Memory (Bytes)",
          gpuSharedMemoryBytesPlaceholder: "Enter Shared Memory (Bytes)",
          gpuDriverVersionLabel: "Driver Version",
          gpuDriverVersionPlaceholder: "Enter Driver Version",
          gpuDriverProviderLabel: "Driver Provider",
          gpuDriverProviderPlaceholder: "Enter Driver Provider",
          gpuClockSpeedBaseHzLabel: "Clock Speed Base (Hz)",
          gpuClockSpeedBaseHzPlaceholder: "Enter Clock Speed Base (Hz)",
          gpuClockSpeedBoostHzLabel: "Clock Speed Boost (Hz)",
          gpuClockSpeedBoostHzPlaceholder: "Enter Clock Speed Boost (Hz)",
          gpuCudaCoresLabel: "CUDA Cores",
          gpuCudaCoresPlaceholder: "Enter CUDA Cores",
          gpuShaderUnitsLabel: "Shader Units",
          gpuShaderUnitsPlaceholder: "Enter Shader Units",
          gpuMaxDisplaySupportLabel: "Max Display Support",
          gpuMaxDisplaySupportPlaceholder: "Enter Max Display Support",
          gpuSupportedApisLabel: "Supported APIs",
          gpuSupportedApisPlaceholder: "Enter Supported APIs",
          gpuHardwareAccelerationLabel: "Hardware Acceleration Enabled",
        },
        processor: {
          title: "CPU",
          cpuNameLabel: "CPU Name",
          cpuNamePlaceholder: "Enter CPU Name",
          cpuVendorLabel: "CPU Vendor",
          cpuVendorPlaceholder: "Enter CPU Vendor",
          cpuSeriesLabel: "CPU Series",
          cpuSeriesPlaceholder: "Enter CPU Series",
          cpuGenerationLabel: "CPU Generation",
          cpuGenerationPlaceholder: "Enter CPU Generation",
          cpuCoreCountLabel: "CPU Core Count",
          cpuCoreCountPlaceholder: "Enter CPU Core Count",
          cpuThreadCountLabel: "CPU Thread Count",
          cpuThreadCountPlaceholder: "Enter CPU Thread Count",
          cpuClockSpeedHzLabel: "CPU Clock Speed (Hz)",
          cpuClockSpeedHzPlaceholder: "Enter CPU Clock Speed (Hz)",
          cpuMaxTurboFrequencyHzLabel: "CPU Max Turbo Frequency (Hz)",
          cpuMaxTurboFrequencyHzPlaceholder:
            "Enter CPU Max Turbo Frequency (Hz)",
          cpuCacheSizeL1BytesLabel: "CPU L1 Cache Size (Bytes)",
          cpuCacheSizeL1BytesPlaceholder: "Enter CPU L1 Cache Size (Bytes)",
          cpuCacheSizeL2BytesLabel: "CPU L2 Cache Size (Bytes)",
          cpuCacheSizeL2BytesPlaceholder: "Enter CPU L2 Cache Size (Bytes)",
          cpuCacheSizeL3BytesLabel: "CPU L3 Cache Size (Bytes)",
          cpuCacheSizeL3BytesPlaceholder: "Enter CPU L3 Cache Size (Bytes)",
          cpuTdpWattLabel: "CPU TDP (Watt)",
          cpuTdpWattPlaceholder: "Enter CPU TDP (Watt)",
          cpuSocketTypeLabel: "CPU Socket Type",
          cpuSocketTypePlaceholder: "Enter CPU Socket Type",
          cpuProcessNodeLabel: "CPU Process Node",
          cpuProcessNodePlaceholder: "Enter CPU Process Node",
        },
        ram: {
          title: "RAM",
          ramSizeBytesLabel: "RAM Size (Bytes)",
          ramSizeBytesPlaceholder: "Enter RAM Size (Bytes)",
          ramGenerationLabel: "Memory Type",
          ramGenerationPlaceholder: "Enter Memory Type",
          ramFormFactorLabel: "RAM Form Factor",
          ramFormFactorPlaceholder: "Enter RAM Form Factor",
          ramSpeedHzLabel: "RAM Speed (Hz)",
          ramSpeedHzPlaceholder: "Enter RAM Speed (Hz)",
          ramEccSupportedLabel: "ECC Supported",
          ramRegisteredLabel: "Registered RAM",
          ramManufacturerLabel: "RAM Manufacturer",
          ramManufacturerPlaceholder: "Enter RAM Manufacturer",
          ramSerialNumberLabel: "RAM Serial Number",
          ramSerialNumberPlaceholder: "Enter RAM Serial Number",
          ramManufactureDateLabel: "RAM Manufacture Date",
          ramManufactureDatePlaceholder: "Enter RAM Manufacture Date",
          ramPartNumberLabel: "RAM Part Number",
          ramPartNumberPlaceholder: "Enter RAM Part Number",
          ramJedecCompliantLabel: "JEDEC Compliant",
        },
        battery: {
          title: "Battery",
          batteryPresenceLabel: "Battery Present",
          batteryTypeLabel: "Battery Type",
          batteryTypePlaceholder: "Enter Battery Type",
          batteryManufacturerLabel: "Battery Manufacturer",
          batteryManufacturerPlaceholder: "Enter Battery Manufacturer",
          batteryModelNameLabel: "Battery Model Name",
          batteryModelNamePlaceholder: "Enter Battery Model Name",
          batterySerialNumberLabel: "Battery Serial Number",
          batterySerialNumberPlaceholder: "Enter Battery Serial Number",
          batteryManufactureDateLabel: "Battery Manufacture Date",
          batteryManufactureDatePlaceholder: "Enter Battery Manufacture Date",
          batteryDesignCapacityMWhLabel: "Battery Design Capacity (mWh)",
          batteryDesignCapacityMWhPlaceholder:
            "Enter Battery Design Capacity (mWh)",
        },
        monitor: {
          title: "Monitor",
          sizeInInchLabel: "Size (Inch)",
          sizeInInchPlaceholder: "Enter Size (Inch)",
          resolutionWidthLabel: "Resolution Width",
          resolutionWidthPlaceholder: "Enter Resolution Width",
          resolutionHeightLabel: "Resolution Height",
          resolutionHeightPlaceholder: "Enter Resolution Height",
          numberOfColorsLabel: "Number of Colors",
          numberOfColorsPlaceholder: "Enter Number of Colors",
          refreshRateHzLabel: "Refresh Rate (Hz)",
          refreshRateHzPlaceholder: "Enter Refresh Rate (Hz)",
          displayTypeLabel: "Display Type",
          displayTypePlaceholder: "Enter Display Type",
          manufactureDateLabel: "Manufacture Date",
          manufactureDatePlaceholder: "Enter Manufacture Date",
          panelTypeLabel: "Panel Type",
          panelTypePlaceholder: "Enter Panel Type",
          aspectRatioLabel: "Aspect Ratio",
          aspectRatioPlaceholder: "Enter Aspect Ratio",
          brightnessLabel: "Brightness",
          brightnessPlaceholder: "Enter Brightness",
          contrastRatioLabel: "Contrast Ratio",
          contrastRatioPlaceholder: "Enter Contrast Ratio",
          colorGamutLabel: "Color Gamut",
          colorGamutPlaceholder: "Enter Color Gamut",
          inputPortsLabel: "Input Ports",
          inputPortsPlaceholder: "Enter Input Ports",
          activePortUsedLabel: "Active Port Used",
          activePortUsedPlaceholder: "Enter Active Port Used",
          touchCapabilityLabel: "Touch Capability",
          touchCapabilityPlaceholder: "Enter Touch Capability",
          displayArrangementLabel: "Display Arrangement",
          displayArrangementPlaceholder: "Enter Display Arrangement",
          rotationPivotModeLabel: "Rotation/Pivot Mode",
          rotationPivotModePlaceholder: "Enter Rotation/Pivot Mode",
        },
        os: {
          title: "Operating System",
          operatingSystemTypeLabel: "Operating System Type",
          operatingSystemTypePlaceholder: "Enter Operating System Type",
          osVersionLabel: "OS Version",
          osVersionPlaceholder: "Enter OS Version",
          osNameLabel: "OS Name",
          osNamePlaceholder: "Enter OS Name",
          osEditionLabel: "OS Edition",
          osEditionPlaceholder: "Enter OS Edition",
          buildNumberLabel: "Build Number",
          buildNumberPlaceholder: "Enter Build Number",
          servicePackPatchLevelLabel: "Service Pack/Patch Level",
          servicePackPatchLevelPlaceholder: "Enter Service Pack/Patch Level",
          securityPatchDateLabel: "Security Patch Date",
          securityPatchDatePlaceholder: "Enter Security Patch Date",
          automaticUpdatesEnabledLabel: "Automatic Updates Enabled",
          kernelVersionLabel: "Kernel Version",
          kernelVersionPlaceholder: "Enter Kernel Version",
          architectureLabel: "Architecture",
          architecturePlaceholder: "Enter Architecture",
          bitnessLabel: "Bitness",
          bitnessPlaceholder: "Enter Bitness",
          withVirtualOsLabel: "With Virtual OS",
          osSupportLifecycleLabel: "OS Support Lifecycle",
          osSupportLifecyclePlaceholder: "Enter OS Support Lifecycle",
          firewallStatusLabel: "Firewall Status",
          firewallStatusPlaceholder: "Enter Firewall Status",
          antivirusSoftwareCompatibilityLabel:
            "Antivirus Software Compatibility",
          antivirusSoftwareCompatibilityPlaceholder:
            "Enter Antivirus Software Compatibility",
        },
        osSetting: {
          title: "OS Setting",
          osInstallDateLabel: "OS Install Date",
          osInstallDatePlaceholder: "Enter OS Install Date",
          bootModeLabel: "Boot Mode",
          bootModePlaceholder: "Enter Boot Mode",
          diskEncryptionEnabledLabel: "Disk Encryption Enabled",
        },
        storage: {
          title: "Storage",
          typeLabel: "Storage Type",
          typePlaceholder: "Select storage type",
          nameLabel: "Product Name / Model",
          namePlaceholder: "Enter product name or model name",
          capacityMBLabel: "Capacity (MB)",
          capacityMBPlaceholder: "Enter capacity in MB",
          storageInterfaceTypeLabel: "Interface Type",
          storageInterfaceTypePlaceholder: "Enter interface type",
          storageFormFactorLabel: "Form Factor",
          storageFormFactorPlaceholder: "Enter form factor",
          storageSlotNumberLabel: "Slot Number",
          storageSlotNumberPlaceholder: "Enter slot number",
          storageManufacturerLabel: "Manufacturer",
          storageManufacturerPlaceholder: "Enter manufacturer",
          storageSerialNumberLabel: "Serial Number",
          storageSerialNumberPlaceholder: "Enter serial number",
          storageFirmwareVersionLabel: "Firmware Version",
          storageFirmwareVersionPlaceholder: "Enter firmware version",
          storageCacheSizeBytesLabel: "Cache Size (Bytes)",
          storageCacheSizeBytesPlaceholder: "Enter cache size in bytes",
          storageNandTypeLabel: "NAND Type",
          storageNandTypePlaceholder: "Enter NAND type",
          storageTrimSupportLabel: "TRIM Support",
          storageTrimSupportPlaceholder: "Is TRIM supported?",
        },
        port: {
          title: "Port Information",
          typeLabel: "Port Type",
          typePlaceholder: "Select port type",
          specificationLabel: "Specification",
          specificationPlaceholder: "Enter port specification",
          numOfPortsLabel: "Number of Ports",
          numOfPortsPlaceholder: "Enter number of ports",
        },
      },
      completed: {
        result: "Result",
        message: "Saved as draft.",
        goToProfile: "Go to profile",
        completedBy: "Completed by:",
        continueAndActivate: "Continue and Activate",
        activate: "Activate",
        activateSuccess: "Catalog has been activated successfully",
        activateModal: {
          title: "Activate Catalog Item",
          description:
            "Once activated, the content cannot be edited. Do you want to proceed?",
          confirm: "Activate",
          cancel: "Cancel",
        },
      },
      common: {
        submitButtonLabel: "Create Catalog",
      },
    },
    progressbar: {
      total: "Total",
      mustItem: "Must Item",
      filled: "filled",
      modeSetting: "Mode Settings",
      mustItemOnly: "Must item only",
    },
  },
  errorBoundary: {
    title: "Failed to load form",
    unknownError: "An unknown error occurred",
    reload: "Reload",
  },
};

export default pagesDeviceCatalogAddEn;
